<template>
    <div>
        <loader v-if="loading"></loader>
        <div v-else>
        <b-form class="p-3 border-bottom clearfix" @submit.prevent.stop="() => updateDay(day)">
                    <b-form-group
                id="input-group-1"
                label="Day:"
                label-for="input-1"
        >
          <b-form-input
                  required
                  v-model.number="day"
                  type="number"
                  placeholder="Day"
          ></b-form-input>
        </b-form-group>

        <div class="row">
          <div class="col-md-6">
            <b-button class="float-right" type="submit" variant="primary">Submit</b-button>
          </div>
        </div>
        </b-form>

        <b-table striped hover class="mt-3" :items="memberships" :fields="fields">
            <template v-slot:cell(created_at)="data">
                {{ data.value | moment("DD/MM/YYYY HH:mm") }}
            </template>
            <template v-slot:cell(expired_at)="data">
                {{ data.value | moment("DD/MM/YYYY HH:mm") }}
            </template>
        </b-table>
        <b-alert :show="memberships.length === 0" variant="warning">Not found</b-alert>
    </div>
        </div>
</template>

<script>
    import GetDriverMemberships from "../../../../store/actions/getDriverMemberships";
    import PostDriverMembershipUpdateDay from '../../../../store/actions/postDriverMembershipUpdateDay';
    import ContentLoader from "../../../../components/ContentLoader";
    import ShowError from "../../../../helpers/showError";

    export default {
        name: 'DriverMembershipComponent',
        data: () => ({
            loading: false,
            day: null,
            fields: [
                'price',
                'days',
                {
                    'key': 'created_at',
                    'label': 'Created',
                    'sortable': true
                },
                {
                    'key': 'expired_at',
                    'label': 'Expired',
                    'sortable': true
                }
            ],
            memberships: []
        }),
        components: {
            loader: ContentLoader,
        },
        created() {
            this.getActions();
        },
        methods: {
            async updateDay(day){
                try {
                    this.loading = true;
                    await PostDriverMembershipUpdateDay({userId: this.$route.params.id, days: day})
                    this.getActions();
                } catch (e) {
                    ShowError(this, e);
                } finally {
                    this.loading = false;
                }
            },
            async getActions() {
                try {
                    this.loading = true;
                    this.memberships = await GetDriverMemberships({
                        userId: this.$route.params.id,
                    });

                } catch (e) {
                    ShowError(this, e);
                } finally {
                    this.loading = false;
                }
            }
        }
    }
</script>